import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonCopyText } from '@components/atoms/button-copy-text';
import { Typography } from '@components/atoms/typography';
import { QrCode } from '@components/moleculs/qr-code';
import { TextField } from '@components/moleculs/text-field';
import { useVerificationUrl } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/hooks/use-verification-url';

import { DesktopNotAllowedContainer } from './styles';

export const DesktopNotAllowedStep: React.FC = () => {
    const { t } = useTranslation();
    const { verificationUrl } = useVerificationUrl();

    return (
        <DesktopNotAllowedContainer>
            <div className='not-allowed-container'>
                <Typography tag='h2' variant='h2' className='title'>
                    {t('docVerificationWidget.desktopNotAllowed.title')}
                </Typography>
                <Typography tag='div' variant='text-bold' color='text-light' className='sub-title'>
                    {t('docVerificationWidget.qrLink.text')}
                </Typography>
                <div className='qr-container'>
                    <QrCode value={verificationUrl} size={135} />
                </div>
                <TextField
                    disabled={true}
                    fullWidth={true}
                    value={verificationUrl}
                    InputProps={{
                        endAdornment: (
                            <ButtonCopyText
                                copyText={verificationUrl}
                                tooltipProps={{
                                    title: t('common.copied'),
                                    placement: 'bottom',
                                }}
                                className='icon'
                            />
                        ),
                    }}
                    inputSize='m'
                    className='link-field'
                />
            </div>
        </DesktopNotAllowedContainer>
    );
};
